




















































import {Component, Vue} from 'vue-property-decorator';
@Component
export default class FormWalktrough extends Vue {
  tab = 0;

  gotoRegister() {
    this.$emit('showForm', false);
  }
  get appTitle() {
    return process.env.VUE_APP_NAME;
  }
}
